import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { addIframeTitles } from '@view/utils/iframeA11y';
import { sanitizeHtml } from '@view/utils/sanitizeHtml';
/**
 * Makes an HTML string safe to inject: strips anything executable and titles
 * untitled `<iframe>`s. `TrustedHTML` / `null` / `undefined` pass through.
 *
 * `useSuspense: false` because `@molecules/Text` calls this on every render,
 * including on the pages that never load a property and so never initialize
 * i18next: the dev index and the hardcoded-English `/404`. Suspending there
 * holds Root's Suspense fallback forever — nothing is ever going to resolve it.
 * Off the property routes the title falls back to the raw key until i18next is
 * ready, and `useTranslation` re-renders us when it is.
 */
export const useSafeHtml = (html) => {
    const { t } = useTranslation(undefined, { useSuspense: false });
    return useMemo(() => {
        if (typeof html !== 'string') {
            return html;
        }
        return addIframeTitles(sanitizeHtml(html), t('iframe/embedded-content'));
    }, [html, t]);
};
